export const contactSection = {
  ar: {
    eyebrow: "تواصل",
    cta: "أرسل رسالتك",
    whatsappCta: "ابدأ محادثة على واتساب",
    whatsappMessage: "مرحباً يعقوب، وصلت من موقعك وأريد مناقشة حل لعملي. هذا ما أريد تحسينه: ",
    expectTitle: "ماذا يحدث بعد رسالتك؟",
    expectations: [
      "أقرأ رسالتك وأسألك عمّا أحتاجه لفهم المشكلة",
      "نحدّد الحل المناسب وما سيشمله التنفيذ",
      "نوضّح التكلفة والمدة قبل قرار البدء — المراسلة لا تلزمك بالتعاقد",
    ],
  },
  en: {
    eyebrow: "Contact",
    cta: "Send your message",
    whatsappCta: "Chat on WhatsApp",
    whatsappMessage: "Hi Yacoub, I found your website and would like to discuss a solution for my business. Here's what I want to improve: ",
    expectTitle: "What happens after your message?",
    expectations: [
      "I read your message and ask what I need to understand the problem",
      "We identify the right solution and what delivery will include",
      "We clarify cost and timing before you decide to proceed — no commitment to hire",
    ],
  },
  fr: {
    eyebrow: "Contact",
    cta: "Envoyez votre message",
    whatsappCta: "Discuter sur WhatsApp",
    whatsappMessage: "Bonjour Yacoub, j'ai découvert votre site et souhaite discuter d'une solution pour mon activité. Voici ce que je souhaite améliorer : ",
    expectTitle: "Que se passe-t-il après votre message ?",
    expectations: [
      "Je lis votre message et pose les questions utiles pour comprendre le besoin",
      "Nous définissons la solution et ce que comprend sa réalisation",
      "Nous précisons le coût et le délai avant votre décision — sans engagement",
    ],
  },
};
